import { Timestamp } from "@bufbuild/protobuf";

import { DateTime } from "luxon";

export const convertTimestampToDate = (t: Timestamp) => {
  const seconds = Number(t.seconds);
  return new Date(seconds * 1000);
};

export const convertToTimestamp = (d: Date) => {
  const t = new Timestamp();
  t.seconds = BigInt(Math.floor(d.getTime() / 1000));
  t.nanos = 0;
  return t;
};

export const formatDateTimeDisplay = (date: Date) => {
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const formattedDate = DateTime.fromJSDate(date)
    .setZone(timezone)
    .toFormat("dd MMM yyyy hh:mm a ZZZZ");
  return formattedDate;
};

// Returns a Promise that resolves after "ms" Milliseconds
export const timeDelay = (ms: number) =>
  new Promise((res) => setTimeout(res, ms));
